"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TALK = exports.TALKS = void 0;
const route_1 = require("../route");
exports.TALKS = route_1.PROJECT.sub("/talks");
exports.TALK = route_1.PROJECT.sub("/talks/:talkId");
